import { gql } from '@apollo/client';

export const UPDATE_DISCRETE_RECEPTOR = gql`
    mutation UpdateDiscreteReceptor($id: Guid!, $input: UpdateDiscreteReceptor!) {
        facility {
            process {
                updateDiscreteReceptor(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
